import { render, staticRenderFns } from "./SeasonList.vue?vue&type=template&id=a243d1ae"
import script from "./SeasonList.vue?vue&type=script&lang=ts"
export * from "./SeasonList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports